
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Form, Radio, Checkbox, Space, TextArea, Input, DatePicker, Grid } from "antd-mobile";
import moment from 'moment';
import RadioImg from '../radioImg';
import { sequenceKeys } from '../../index/config';
import './index.scss';

const InputLimt = 10
//控制input框是否显示输入数量限制
const InputShowCount = false

const QuestionItem = (props) => {

    const { form, item } = props
    const [pickerVisible, setPickerVisible] = useState(false)

    const selectOptionValue = Form.useWatch(`question${item.index}`, form)

    const renderOptions = () => {
        let elment = null
        //2填空
        if (item.questionType == 2) {
            if (item.optionList && item.optionList.length > 1) {
                elment = (
                    <Space direction='vertical'>
                        <Form.Array
                            name={`question${item.index}`}
                            initialValue={item.optionList}
                        >
                            {
                                fields => fields.map(({ index }) => {
                                    const option = item.optionList[index]
                                    return (
                                        <Form.Item
                                            name={[index, 'content']}
                                            noStyle
                                            rules={[{ required: option.isAnswer, message: `第${item.index + 1}题有必填项您还没填写` }]}
                                        >
                                            {
                                                InputShowCount ?
                                                <TextArea className='input-textarea' maxLength={InputLimt} rows={1} showCount placeholder={option.isAnswer ? '必填' : '选填'} />
                                                :<Input placeholder={option.isAnswer ? '必填' : '选填'} />
                                            }
                                        </Form.Item>
                                    )

                                })
                            }
                        </Form.Array>
                    </Space>
                )
            }else {
                elment = InputShowCount ?
                    <TextArea className='input-textarea' maxLength={InputLimt} rows={1} showCount placeholder={'请输入'} />
                    :<Input placeholder={'请输入'} />
            }
            
        } else if (item.questionType == 3) {
            //3简答
            elment = (
                <TextArea maxLength={100}
                    rows={4}
                    showCount
                    placeholder={'请输入：'}
                    autoSize={true}
                />
            )
        }else if ([4, 5].includes(item.questionType)) {
            //4: date; 5:dateTime
            elment = (
                <Form.Item
                    name={`question${item.index}`}
                    noStyle
                    trigger='onConfirm'
                    initialValue={item.answer ? moment(item.answer).toDate() : null}
                >
                    <DatePicker visible={pickerVisible}
                        precision={item.questionType == 5 ? 'second': undefined}
                        confirmText={<span style={{color: '#CEBF7D'}}>确认</span>}
                        onClose={() => {
                            setPickerVisible(false)
                        }}>
                        { value => {
                            return (
                                <div className={`date-picker-value${value ? '': ' placeholder'}`}
                                    onClick={() => {
                                        setPickerVisible(true)
                                    }}
                                >
                                    {value ? moment(value).format(item.questionType == 5 ? 'YYYY-MM-DD HH:mm:ss':'YYYY-MM-DD') : '请选择'}
                                </div>
                            )
                        }}
                    </DatePicker>
                </Form.Item>
            )
        } else if (item.type == 'img') {
            const XGroup = item.questionType === 1 ? Checkbox.Group: Radio.Group
            elment = (
                <XGroup>
                     <Space wrap>
                        {
                            item.optionList &&
                            item.optionList.map((option, i) => {
                                return (
                                    <Fragment key={i}>
                                        <RadioImg
                                            checkbox={ item.questionType == 1 }
                                            icon={() => <></>}
                                            img={option.optionImg}
                                            value={option.optionNo}
                                        >
                                            {`${sequenceKeys[i]}、${option.optionText}`}
                                        </RadioImg>
                                    </Fragment>
                                )
                            })
                        }
                    </Space>
                </XGroup>
            )
        }else if (item.questionType == 0) {
            //单选
            elment = (
                <Radio.Group>
                    <Space direction='vertical'>
                        {
                            item.optionList &&
                            item.optionList.map((option, i) => {
                                return (
                                    <Fragment key={i}>
                                        <Radio
                                            icon={() => <></>}
                                            value={option.optionNo}
                                        >
                                            {`${sequenceKeys[i]}、${option.optionText}`}
                                        </Radio>
                                        {
                                            // 1:包含文本输入
                                            option.optionType == 1 && 
                                            (selectOptionValue == option.optionNo || item.answer?.content) &&
                                            <Form.Item
                                                noStyle
                                                name={`content-${item.index}-${option.optionNo}`}
                                                initialValue={item.answer?.content}
                                                rules={[{ required: option.isAnswer, message: `第${item.index + 1}题有必填项您还没填写` }]}
                                            >
                                                {
                                                    InputShowCount ?
                                                    <TextArea className='other-textarea' maxLength={InputLimt} rows={1} showCount placeholder={option.isAnswer ? '必填' : '选填'} />
                                                    :<Input className='other-input' placeholder={option.isAnswer ? '必填' : '选填'}></Input>
                                                }
                                            </Form.Item>
                                        }
                                    </Fragment>
                                )
                            })
                        }
                    </Space>
                </Radio.Group>
            )
        } else if (item.questionType == 1) {
            //多选
            elment = (
                <Checkbox.Group>
                    <Space direction='vertical'>
                        {
                            item.optionList &&
                            item.optionList.map((option, i) => {
                                return (
                                    <Fragment key={i}>
                                        <Checkbox
                                            icon={() => <></>}
                                            value={option.optionNo}
                                        >
                                            {`${sequenceKeys[i]}、${option.optionText}`}
                                        </Checkbox>
                                        {
                                            // 1:包含文本输入
                                            option.optionType == 1 && selectOptionValue?.includes(option.optionNo) &&
                                            <Form.Item
                                                noStyle
                                                name={`content-${item.index}-${option.optionNo}`}
                                                initialValue={option.content}
                                                rules={[{ required: option.isAnswer, message: `第${item.index + 1}题有必填项您还没填写` }]}
                                            >
                                                <Input className='other-input' placeholder={option.isAnswer ? '必填' : '选填'}></Input>
                                            </Form.Item>
                                        }
                                    </Fragment>
                                )
                            })
                        }
                    </Space>
                </Checkbox.Group>
            )
        }
        return elment
    }

    const inputOption = useMemo(()=>{
        if(item.questionType == 2 && item.optionList?.length > 1) {
            return true
        }else if([4, 5].includes(item.questionType)) {
            return true
        }
        return false
    },[])

    const questionTitle = useMemo(() => {
        let title = `${item.index + 1}. ${item.stemText}`
        if (item.questionType == 0) {
            title += '（单选）'
        } else if (item.questionType == 1 ) {
            title += '（多选）'
        }else if (item.questionType == 2 ) {
            // 填空
        }else if (item.questionType == 3 ) {
            // 简答
        }else if ([4, 5].includes(item.questionType)) {
            // 日期/时间
        }
        return title
    },[])

    const initValue = ()=> {
        if(Object.prototype.toString.call(item.answer) == '[object Object]') {
            return item.answer.value == null ? undefined: item.answer.value
        }else if([4, 5].includes(item.questionType)) {
            return undefined
        }else {
            return item.answer == null ? undefined: item.answer
        }
    }
    return (
        <div className="question-item">
            <Form.Item
                name={inputOption ? undefined: `question${item.index}`}
                label={<span className={`question-title${item.isAnswer ? ' require' : ''}`}>{questionTitle}</span>}
                hasFeedback={false}
                initialValue={ inputOption ? undefined: initValue() }
                rules={[
                    {
                        required: inputOption ? false : item.isAnswer,
                        message: `第${item.index + 1}题为${[4, 5].includes(item.questionType) ? '必填' : '必选'},您还没有${['input', 'textarea'].includes(item.type) ? '填写' : '选择'}`
                    },
                ]}
            >
                {renderOptions()}
            </Form.Item>
        </div>
    )
}

export default QuestionItem;